import { render } from "./ListClientes.vue?vue&type=template&id=6298ee60&scoped=true"
import script from "./ListClientes.vue?vue&type=script&lang=js"
export * from "./ListClientes.vue?vue&type=script&lang=js"

import "./ListClientes.vue?vue&type=style&index=0&id=6298ee60&scoped=true&lang=css"
import "./ListClientes.vue?vue&type=style&index=1&id=6298ee60&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6298ee60"]])

export default __exports__